export interface IPointerConfig
{
	id            ? : number;
	localX        ? : number;
	localY        ? : number;
	time          ? : number;
	originalEvent ? : Event;
}

export class Pointer
{

	public id     : number;
	public startX : number;
	public startY : number;
	public localX : number;
	public localY : number;
	public time   : number;
	public originalEvent : Event; // MouseEvent or TouchEvent
	public canceled : boolean = false;

	public offsetX : number = 0;
	public offsetY : number = 0;
	public dx : number = 0;
	public dy : number = 0;
	public userData : any;

	constructor(config?: IPointerConfig)
	{
		if (config)
		{
			this.id            = config.id;
			this.startX        = config.localX;
			this.startY        = config.localY;
			this.localX        = config.localX;
			this.localY        = config.localY;
			this.time          = config.time;
			this.originalEvent = config.originalEvent;
		}
	}

	public clone()
	{
		var cloned = new Pointer();

		for (var key in this) {
			if (this.hasOwnProperty(key))
			{
				cloned[<any>key] = this[key];
			}
		}

		return cloned;
	}
}